// src/Components/comofunciona.jsx
import React from "react";
import "./comofunciona.css";

function ComoFunciona() {
  return (
    <section id="ComoFunciona" className="como-funciona-section">
      <div className="container">

        {/* TÍTULO */}
        <div className="titulo-bloco">
          <h2>Como funciona</h2>
          <span className="linha-destaque"></span>
          <p className="subtitulo">
            Um processo claro, técnico e focado na sua aprovação acadêmica
          </p>
        </div>

        {/* TIMELINE */}
        <div className="timeline">

          <div className="timeline-item">
            <div className="timeline-numero">1</div>
            <div className="timeline-conteudo">
              <h4>Envio do material</h4>
              <p>
                Você nos encaminha seu TCC, artigo ou material acadêmico
                para análise técnica inicial.
              </p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-numero">2</div>
            <div className="timeline-conteudo">
              <h4>Análise técnica</h4>
              <p>
                Avaliamos a estrutura, normas, metodologia e identificamos
                pontos críticos e oportunidades de melhoria.
              </p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-numero">3</div>
            <div className="timeline-conteudo">
              <h4>Plano de orientação</h4>
              <p>
                Definimos um plano claro de correções e orientações,
                alinhado às exigências acadêmicas.
              </p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-numero">4</div>
            <div className="timeline-conteudo">
              <h4>Acompanhamento final</h4>
              <p>
                Acompanhamos você até a entrega final ou apresentação
                em banca, garantindo segurança técnica.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default ComoFunciona;
